import React from 'react';
import { Tooltip } from '@mui/material';
import {ColoredSymbolProps} from './ColoredSymbol.props';
import {colors} from '../../../ScalarSpreadsheet/constants';

const ColoredSymbol = ({ symbol, colorIndex, value }: ColoredSymbolProps) => (
  <Tooltip placement="top" title={value ?? ''}>
    <span style={{ color: colorIndex >= 0 ? colors[colorIndex] : undefined }}>{symbol}</span>
  </Tooltip>
);

export default ColoredSymbol;